export default "__VITE_ASSET__DOPTIBrz__"